import { render, staticRenderFns } from "./PFDeRegistrationFront.vue?vue&type=template&id=54ea7284"
import script from "./PFDeRegistrationFront.vue?vue&type=script&lang=js"
export * from "./PFDeRegistrationFront.vue?vue&type=script&lang=js"
import style0 from "./PFDeRegistrationFront.vue?vue&type=style&index=0&id=54ea7284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports